module.exports = __webpack_public_path__ + "static/second-42b6adf086c3158e05b432d1c6e803b1.svg";